"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = require("react");

var ContextConsumerComposer =
/** @class */
function (_super) {
  __extends(ContextConsumerComposer, _super);

  function ContextConsumerComposer() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  ContextConsumerComposer.prototype.render = function () {
    var _a = this.props,
        children = _a.children,
        components = _a.components;
    return renderRecursive(children, components);
  };

  return ContextConsumerComposer;
}(React.Component);

exports.ContextConsumerComposer = ContextConsumerComposer;
/**
 * Recursively build up elements from props.components and accumulate `results` along the way.
 */

var renderRecursive = function renderRecursive(render, remaining, results) {
  if (results === void 0) {
    results = [];
  } // Once components is exhausted, we can render out the results array.


  if (!remaining[0]) {
    return render(results);
  } // Continue recursion for remaining items.
  // results.concat([value]) ensures [...results, value] instead of [...results, ...value]


  function nextRender(value) {
    return renderRecursive(render, remaining.slice(1), results.concat([value]));
  }

  var Item = remaining[0]; // When it is an element, enhance the element's props with the render prop.

  return React.cloneElement(React.createElement(Item, null, nextRender), {
    displayName: Item.displayName
  });
};